import React from "react"
import { FlatList, FlatListProps, ListRenderItem, StyleProp, StyleSheet, ViewStyle } from "react-native"

type Props = FlatListProps<any> & {
  id: string;
  data: any[];
  renderItem: (ListRenderItem<any>);
  keyExtractor: (item: any, index: number) => string;
  contentContainerStyle?: StyleProp<ViewStyle>;
}

const DragScrollContainer: React.FC<Props> = ({
  id, data, renderItem, keyExtractor, contentContainerStyle={}, ...props
}: Props) => {

  return (
    <FlatList
      nativeID={`horizontalList-${id}`}
      data={data}
      horizontal
      contentContainerStyle={[styles.flatListContainer, contentContainerStyle]}
      keyExtractor={keyExtractor}
      renderItem={renderItem}
      {...props}
    />
  )
}

export default DragScrollContainer

const styles = StyleSheet.create({
  flatListContainer: {
    gap: 10,
    paddingHorizontal: 5,
    paddingVertical: 5,
  },
})